import initTabelaGenerica from '../mixins/initTabelaGenerica'
import { URLS } from '../constants/urls'
import { Grid, html as htmlGrid } from 'gridjs'

export default {
	mixins: [initTabelaGenerica],
	props: { query: '' },
	data() {
		return {
			_gridThenCallback: null,
			_gridTotalCallback: null,
			listaFundacaoAtendimentoSai: [],
			tabelaCalendarioReuniaoSai: null,
			columns: [
				{ id: 'id', name: 'ID', hidden: true },
				{ id: 'politica', name: 'Politica', hidden: true },
				{
					id: 'nome',
					name: 'Nome da Fundação',
					attributes: {
						'sticky-column-1': true,
						'sticky-header': true,
					},
					hidden: false,
					width: '140px',
					formatter: (cell, row) => {
						const politica = row?.cells[1]?.data
						return htmlGrid(`<div class="inline-flex items-center max-w-[180px] "  >
							<svg class="h-40 w-40 shrink-0" style="${GLOBAL.generateAvatarColor(politica)}">
									<use xlink:href="#icon_person"></use>
								</svg>
							<span class="one-line max-w-[180px]" title="${cell}">${cell || ''}</span>
						</div>`)
					},
					/* 			sort: {
						compare: (a, b) => {
							const fundacaoA = this.listaFundacaoAtendimentoSai.find(
								(itemFundacao) => itemFundacao.nome_fundacao === a
							)
							const fundacaoB = this.listaFundacaoAtendimentoSai.find(
								(itemFundacao) => itemFundacao.nome_fundacao === b
							)

							if (
								parseInt(fundacaoA.politica) !== parseInt(fundacaoB.politica)
							) {
								return (
									parseInt(fundacaoA.politica) - parseInt(fundacaoB.politica)
								)
							}
						},
					}, */

					sort: false,
				},
				{
					id: 'ultimo_atendimento',
					name: 'Ultimo Atendimento',
					hidden: false,
					width: '70px',
					formatter: (cell, row) => {
						return htmlGrid(`<div class="inline-flex items-center max-w-[180px] "  >
							<span class="one-line max-w-[180px]">Há ${cell || '0'} meses</span>
						</div>`)
					},
				},
				{
					id: 'fundos',
					name: 'Fundos',
					hidden: false,
					width: '95px',
					sort: false,
					formatter: (cell, row) => {
						return htmlGrid(`<div class="inline-flex items-center max-w-[180px] "  >
							<span class="one-line max-w-[180px]" title="${cell}">${
							cell?.join(', ') || ''
						}</span>
						</div>`)
					},
				},
			],
		}
	},
	methods: {
		iniciaTabelaCalendarioReuniaoSai() {
			const tabela = document.querySelector('#tabela_reuniao_calendario_sai')
			/* 	let sortColumn = null
			let sortOrder = 'asc' */
			// Guarda localmente essas duas callbacks para podermos reaplicá‐las depois
			this._gridThenCallback = (responseAtendimentos) => {
				const {
					meses_clientes_sem_reuniao,
					meses_clientes_sem_reuniao_ano_atual,
				} = responseAtendimentos

				const listaAtendimentos = [
					...meses_clientes_sem_reuniao,
					...meses_clientes_sem_reuniao_ano_atual,
				]
				this.listaFundacaoAtendimentoSai = listaAtendimentos
				return this.transformDataAtendimentoFundacao(listaAtendimentos)
			}

			this._gridTotalCallback = (responseAtendimentos) => {
				return responseAtendimentos.pagination?.total_items || 0
			}

			const optionsPaginacao = {
				pagination: {
					enabled: true,
					limit: 10,
					summary: true,
					server: {
						url: (urlApi, page, limit) => {
							return `${urlApi}&page=${page + 1}&per_page=${limit}`
						},
					},
				},
				language: {
					pagination: {
						previous: 'Anterior',
						next: 'Próximo',
						navigate: (page, pages) => `Página ${page} de ${pages}`,
						page: (page) => `Página ${page}`,
						showing: 'Mostrando',
						of: 'de',
						to: 'a',
						results: 'resultados',
					},
				},
			}

			const optionsSort = {
				sort: {
					multiColumn: false,
					server: {
						url: (prev, columns) => {
							if (!columns.length || columns[0].index !== 3) return prev

							const col = columns[0]
							const dir = col.direction === 1 ? 'asc' : 'desc'
							return `${prev}&sort_order=${dir}`
						},
					},
				},
			}

			const optionsSearch = {
				search: {
					server: {
						url: (prev, keyword) => `${prev}&search=${keyword}`,
					},
				},
			}

			this.tabelaCalendarioReuniaoSai = this.iniciarTabelaGenerica(
				this.columns,
				`${window.origin}${URLS.atendimento_reuniao_sai}${this.query}`,
				this._gridThenCallback,
				this._gridTotalCallback,
				{ ...optionsPaginacao, ...optionsSort, ...optionsSearch }
			)

			/* 	this.tabelaCalendarioReuniaoSai.on('sort', (column, direction) => {
				// Só permite ordenação server-side para 'ultimo_atendimento'
				if (column.id === 'ultimo_atendimento') {
					sortColumn = column.id
					sortOrder = direction
				} else {
					sortColumn = null
					sortOrder = 'asc'
				}
				this.tabelaCalendarioReuniaoSai
					.updateConfig({
						server: {
							url: (urlApi, page, limit) => {
								let url = `${urlApi}&page=${page + 1}&per_page=${limit}`
								if (sortColumn) {
									url += `&sort_by=${sortColumn}&sort_order=${sortOrder}`
								}
								return url
							},
							then: this._gridThenCallback,
							total: this._gridTotalCallback,
						},
					})
					.forceRender()
			}) */

			this.tabelaCalendarioReuniaoSai.render(tabela)
		},

		transformDataAtendimentoFundacao(atendimentos) {
			return atendimentos.map((itemAtendimento) => {
				const dataAtendimento = new Date(itemAtendimento.data_reuniao)

				return {
					id: itemAtendimento.id_fundacao,
					politica: itemAtendimento.politica || '0',
					nome: itemAtendimento.nome_fundacao,
					ultimo_atendimento: Quasar.date.getDateDiff(
						new Date(),
						dataAtendimento,
						'months'
					),
					fundos: itemAtendimento.fundos_fundacao,
				}
			})
		},

		atualizarTabelaComNovaQuery() {
			if (!this.tabelaCalendarioReuniaoSai) return

			const novaUrl = window.origin + URLS.atendimento_reuniao_sai + this.query

			this.tabelaCalendarioReuniaoSai
				.updateConfig({
					server: {
						url: novaUrl,
						then: this._gridThenCallback,
						total: this._gridTotalCallback,
					},
				})
				.forceRender()
		},
	},
	watch: {
		query(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.atualizarTabelaComNovaQuery()
			}
		},
	},
	mounted() {
		this.iniciaTabelaCalendarioReuniaoSai()
	},
	template: `
        <table
			id="tabela_reuniao_calendario_sai"
			class="!flex"
			js-table-ordenation
			style="margin-inline: 1rem"></table>
    `,
}
